export enum ELocalStorageItems {
  SAVED_SITES = 'savedSites',
  SAVED_SITE_PLAN_PREFERENCES = 'savedSitePlanPreferences',
  TIMELINE_GROUP_COL_WIDTH = 'timelineGroupColWidth',
  DONT_SHOW_CLEAR_ALL = 'hideClearAllNotificationsModal',
  COLLAPSED_SIDE_PANEL_ITEMS = 'collapsedSidePanelItems',
  GROUP_SIZES = 'group_sizes',
}
